import React from 'react';
import style from './css/benefits.module.css';
import { FaLaptopCode, FaRocket, FaUsers } from 'react-icons/fa';
import { RiGuideFill } from "react-icons/ri";
import { GrPlan } from "react-icons/gr";
import { GiStrong } from "react-icons/gi";

const benefits = [
  {
    icon: <FaLaptopCode />,
    title: 'In-demand IT Skills',
    desc: 'The top 5 most in-demand IT skills employers are hiring for right now',
  },
  {
    icon: <RiGuideFill />,
    title: 'Tech Roadmap',
    desc: 'A step-by-step roadmap to start your journey in tech (even with no experience!)',
  },
  {
    icon: <GrPlan />,
    title: 'Career Plan Guide',
    desc: 'Free career planning worksheet to help you choose the right IT course',
  },
  {
    icon: <FaRocket />,
    title: 'Insider Insight',
    desc: 'Insider insights on certifications that boost your salary & job prospects',
  },
  {
    icon: <GiStrong />,
    title: 'Strong Portfolio',
    desc: 'Tips on how to get hands-on experience & build a strong portfolio',
  },
  {
    icon: <FaUsers />,
    title: 'Community Support',
    desc: 'Join a supportive network of learners and mentors.',
  },
];

export default function Benefits() {
  return (
    <section className={style.benefitSection}>
    <h2 className={style.sectionTitle}>Benefits</h2>
    <div className={style.grid}>
      {benefits.map((item, index) => (
        <div key={index} className={style.card}>
          <div className={style.cardInner}>
            <div className={style.cardFront}>
              <div className={style.icon}>{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
            <div className={style.cardBack}>
              <h3>{item.title}</h3>
              <p>Discover more about {item.title.toLowerCase()} with us.</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
  );
}